import React from "react";
import { useTranslation } from "react-i18next";
import { List, Ellipsis } from "antd-mobile";

import { CustomCard } from "../../../../components";
import { moneyFormat } from "../../../../plugins/numberFormat";
import { getUserCurrency } from "../../../../plugins/utils";
import "./style.scss";

function ApplyRecordItem({ item }) {
  const { t } = useTranslation();
  const userCurrency = getUserCurrency();
  const statusDict = {
    0: {
      color: "var(--adm-color-warning)",
      text: t("personal.agentList.applyRecord.status.inProcess"),
    },
    1: {
      color: "var(--adm-color-success)",
      text: t("personal.agentList.applyRecord.status.success"),
    },
    2: {
      color: "var(--adm-color-danger)",
      text: t("personal.agentList.applyRecord.status.fail"),
    },
  };
  return (
    <CustomCard
      title={<Ellipsis direction="end" content={item.title ?? "-"} />}
      extra={
        <span
          style={{
            color: statusDict[item.status]?.color,
            fontSize: "var(--fontSetting-middle)",
          }}
        >
          {statusDict[item.status]?.text}
        </span>
      }
    >
      <List
        style={{
          "--padding-left": 0,
          "--padding-right": 0,
          "--border-top": "none",
          "--border-bottom": "none",
        }}
        className="agent-mobile-apply-record-custom-list"
      >
        <List.Item extra={item.agent_promotion_trans_id ?? "-"}>
          {t("personal.agentList.applyRecord.promotionId")}
        </List.Item>
        <List.Item extra={item.created_at ?? "-"}>
          {t("personal.agentList.applyRecord.applyTime")}
        </List.Item>
        <List.Item extra={item.trans_id ?? "-"}>
          {t("personal.agentList.applyRecord.transId")}
        </List.Item>
        {item.status != 0 ? (
          <List.Item extra={item.settled_at ?? "-"}>
            {t("personal.agentList.applyRecord.reviewTime")}
          </List.Item>
        ) : (
          ""
        )}
        {item.status == 2 ? (
          <List.Item extra={item.remark ?? "-"}>
            {t("personal.agentList.applyRecord.refuseReason")}
          </List.Item>
        ) : (
          ""
        )}
        {item.status == 1 ? (
          <List.Item
            extra={
              item.bonus_amount ? (
                <span
                  style={{
                    color: "var(--adm-color-primary)",
                    fontSize: "var(--fontSetting-normal)",
                  }}
                >
                  {moneyFormat(item.bonus_amount)} {userCurrency}
                </span>
              ) : (
                "-"
              )
            }
          >
            {t("personal.agentList.applyRecord.bonus")}
          </List.Item>
        ) : (
          ""
        )}
      </List>
    </CustomCard>
  );
}

export default ApplyRecordItem;
